<template>
  <div>
    <p class="message" v-html="$t('discount.voucher.cardTypeError.info')"></p>
    <button class="primary-button" @click="onTryAgainClick">
      {{ $t('discount.voucher.cardTypeError.button') }}
    </button>
  </div>
</template>
<style scoped>
@import '../../../assets/css/button-style.css';

.message {
  margin-bottom: 16px;
}
</style>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'card-type-error',
  methods: {
    ...mapActions({
      setVoucherWizardStep: 'setVoucherWizardStep',
    }),
    onTryAgainClick() {
      this.setVoucherWizardStep('verification');
    },
  },
};
</script>
